var ButtonDropdown = require("components/utility/ButtonDropdown");
var DropDownOptions = require("components/utility/DropDownOptions");

var Glyphicon = require("components/utility/icons/Glyphicon");

require("utility/pagination_controls.scss");

var PaginationControls = function(props) {
	var page = props.page;
	var startIndex = (page - 1) * props.perPage;
	var endIndex = Math.min(startIndex + props.perPage, props.totalCount);
	var maxPage = Math.ceil(props.totalCount / props.perPage);

	var setPage = (pageIndex, e) => {
		$wr.nope(e)
		if (props.onPageChange) { props.onPageChange(pageIndex); }
	}

	if (props.perPageOptions) {
		var setPerPage = (perPage, e) => {
			if (props.onPageChange) { props.onPageChange(1, perPage); }
		}

		var perPageOps = DropDownOptions.Button.simpleText({
			options: props.perPageOptions.map(x => x.toString()), onClick: setPerPage
		});
		var perPageMenu = (
			<span className="perPage">
				(<ButtonDropdown text={ "Show: " + props.perPage } dropdownDisplay="link">
					{ perPageOps }
				</ButtonDropdown>)
			</span>
		)
	}

	return (
		<div className="paginationControls hideOnPrint">
			<span style={{ visibility: (page == 1 ? "hidden" : "visible") }}>
				<a href="#" className="hideOnPrint control"
					onClick={ setPage.bind(this, 1) }>
					<Glyphicon icon="backward" /> First
				</a>
				<a href="#" className="hideOnPrint control"
					onClick={ setPage.bind(this, page - 1) }>
					<Glyphicon icon="triangle-left" /> Previous
				</a>
			</span>
			<span className="pageLabel">
				{ startIndex + 1 }-{ endIndex } of { props.totalCount } { perPageMenu }
			</span>
			<span style={{ visibility: (page == maxPage ? "hidden" : "visible") }}>
				<a href="#" className="hideOnPrint control"
					onClick={ setPage.bind(this, page + 1) }>
					Next <Glyphicon icon="triangle-right" />
				</a>
				<a href="#" className="hideOnPrint control"
					onClick={ setPage.bind(this, maxPage) }>
					Last <Glyphicon icon="forward" />
				</a>
			</span>
		</div>
	);
}

PaginationControls.propTypes = StrictPropTypes({
	page: PropTypes.number.isRequired,
	perPage: PropTypes.number.isRequired,
	totalCount: PropTypes.number.isRequired,

	perPageOptions: PropTypes.array,

	// 1st arg, page number. 2nd arg (optional) perPage number
	onPageChange: PropTypes.func,
});

PaginationControls.DEFAULT_PAGE_OPTIONS = [20, 50, 100, 250, 1000];

module.exports = PaginationControls;



// WEBPACK FOOTER //
// ./modules/components/utility/PaginationControls.js